import React from 'react';
import { FaLinkedin } from 'react-icons/fa';

const LinkedInLoginButton = ({ square = false, iconOnly = false }) => {
  const handleLinkedInLogin = (e) => {
    e.preventDefault();
    
    const state = Math.random().toString(36).substring(2, 15);
    sessionStorage.setItem('linkedinState', state);
    
    const clientId = process.env.REACT_APP_LINKEDIN_CLIENT_ID;
    
    if (!clientId) {
      console.error('LinkedIn Client ID is not defined in environment variables');
      alert('LinkedIn login is not properly configured. Please contact support.');
      return;
    }
    
    const currentPath = window.location.pathname;
    const redirectUri = currentPath === '/extension-auth' 
      ? `${window.location.origin}/extension-auth`
      : `${window.location.origin}/login`;
    
    const params = new URLSearchParams({
      response_type: 'code',
      client_id: clientId,
      redirect_uri: redirectUri,
      state: state,
      scope: 'profile email openid'
    });
    
    window.location.href = `https://www.linkedin.com/oauth/v2/authorization?${params.toString()}`;
  };

  if (iconOnly) {
    return (
      <button
        onClick={handleLinkedInLogin}
        type="button"
        title="Sign in with LinkedIn"
        aria-label="Sign in with LinkedIn"
        className="w-full flex items-center justify-center gap-2 h-12 px-4 rounded-lg border border-gray-200 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 hover:border-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500/20 transition-all duration-200"
      >
        <FaLinkedin className="h-5 w-5 text-[#0077b5]" />
        LinkedIn
      </button>
    );
  }

  if (square) {
    return (
      <button
        onClick={handleLinkedInLogin}
        type="button"
        className="flex items-center justify-center w-[240px] h-10 rounded-lg border border-gray-200 bg-white text-sm text-gray-700 hover:bg-gray-50 hover:border-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500/20 transition-all duration-150"
      >
        <FaLinkedin className="h-[18px] w-[18px] mr-2.5 text-[#0077b5]" />
        <span>Continue with LinkedIn</span>
      </button>
    );
  }

  return (
    <button
      onClick={handleLinkedInLogin}
      type="button"
        className="w-full flex items-center justify-center h-12 px-4 rounded-xl border border-gray-200 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 hover:border-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500/20 transition-all duration-200"
    >
      <FaLinkedin className="h-[18px] w-[18px] mr-2.5 text-[#0077b5]" />
      Continue with LinkedIn
    </button>
  );
};

export default LinkedInLoginButton;
